export function groupNewestSuppliers (data) {
  return Object.values(groupSuppliers(data)).sort((a, b) => +a.price - +b.price)
}

export function groupSuppliers (data) {
  return data.reduce((suppliers, supplier) => {
    if (!suppliers.hasOwnProperty(supplier.supplier_id)) {
      suppliers[supplier.supplier_id] = supplier
    }
    return suppliers
  }, {})
}
